import * as React from 'react';
import moment, { Moment } from 'moment';
import { styled } from '@mui/material/styles';
import FormHelperText from '@mui/material/FormHelperText';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker as Input } from '@mui/x-date-pickers/DatePicker';

const StyledInput= styled(Input)({
  width: '100%',
});

interface IDatePicker {
  label?: string;
  id: string;
  setValue: any;
  error?: boolean;
  helperText?: string;
  defaultValue?: string | null;
  disabled?: boolean;
  required?: boolean;
};

const DatePicker = ({ required = false, id, setValue, error = false, helperText, defaultValue, disabled = false}: IDatePicker) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <StyledInput
        defaultValue={defaultValue ? moment.utc(defaultValue) : null}
        name={id}
        disabled={disabled}
        slotProps={{ textField: { size: 'small', required } }}
        sx={disabled ? {} : {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: error ? 'error.main' : 'grey.500',
            },
            '&:hover fieldset': {
              borderColor: error ? 'error.main' : 'primary.main',
            },
          },
        }}
        onChange={(value: Moment | null) => {
          setValue(id, moment.utc(value))
        }}
      />
      {error && helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </LocalizationProvider>
  );
};

export default DatePicker;
